import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import MzAlert from "@markaaz/ui/MzAlert";
import I18n from "i18next";
import MzButton from "@markaaz/ui/MzButton";
import contractTerms from "../../../data/contractTerms-data.json";
import CheckboxField from "components/common/CheckboxField/CheckboxField";
import CheckGrid from "components/common/CheckGrid";

const sx = {
  wrapper: {
    width: "740px",
    gap: "10px",
    color: "darkBlue.c100",
    display: "flex",
    flexDirection: "column"
  },
  pageWrapper: {
    gap: "40px",
    display: "flex",
    flexDirection: "column"
  },
  body: {
    color: "darkBlue.c100",
    marginBottom: "40px",
    maxWidth: "860px"
  }
};

export default function ContractTermsMain({
  dataObjectColumns,
  monitoringColumns,
  matchingColumns,
  showNotification,
  values,
  submitInProgress,
  isSuperUser,
  userRole,
  onAlertClose,
  onSubmit,
  onCheckboxChange
}) {
  return (
    <Box sx={sx.pageWrapper}>
      <Typography variant="body2" sx={sx.body}>
        {I18n.t("contractTerms.contractTermsDsc")}
      </Typography>
      {contractTerms.map((contract) => {
        return (
          <Box sx={{ ...sx.pageWrapper, ...contract.sx }}>
            <Box sx={sx.wrapper}>
              <Typography variant="h6">{contract.section}</Typography>
              <Typography variant="body2">{contract.description}</Typography>
            </Box>
            {isSuperUser && userRole === "STAFF_SUPER_USER" ? (
              <Box>
                {contract.items.map((items) => {
                  return (
                    <CheckboxField items={items} rowData={items} onCheckboxChange={onCheckboxChange} values={values} />
                  );
                })}
              </Box>
            ) : (
              <CheckGrid
                columns={
                  contract.section === "Monitoring"
                    ? monitoringColumns
                    : contract.section === "Matching"
                    ? matchingColumns
                    : dataObjectColumns
                }
                rows={contract.items.map((item) => {
                  let row = item;
                  row.checked = values[item.checkboxKey];
                  return row;
                })}
              />
            )}
          </Box>
        );
      })}

      <Stack direction="row" gap={10} alignItems="center">
        {isSuperUser && userRole === "STAFF_SUPER_USER" && (
          <MzButton variant="contained" color="primary" size="large" onClick={onSubmit} loading={submitInProgress}>
            {I18n.t("common.submit")}
          </MzButton>
        )}
        {showNotification.message && (
          <MzAlert
            sx={{ alignItems: "center" }}
            severity={showNotification.type === "success" ? "success" : "error"}
            onClose={onAlertClose}
          >
            {showNotification.message}
          </MzAlert>
        )}
      </Stack>
    </Box>
  );
}
